export default function TriangleMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1786)">
                <rect width="100%" height="100%" fill="#1C5DCC" />
                <path d="M500 666.667L1000 1000H0L500 666.667Z" fill="#FF89C2" />
                <path d="M500 333.333L1000 666.667H0L500 333.333Z" fill="#FF89C2" />
                <path d="M500 0L1000 333.333H0L500 0Z" fill="#FF89C2" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1786">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}